import { OptionsQuestion } from '@/config/types';

export function subjectivQuestion(quizQuestion: any, quizAnswers: any[]): OptionsQuestion {
  const find = quizAnswers.find(
    ({ fkQuizQuestion }) => fkQuizQuestion === quizQuestion.cdQuizQuestion,
  );

  return { value: find.vlAnswer, initChecked: true };
}
